import Choices from 'choices.js';

const element = document.querySelector('[name="field_research_interests[]"]');
const elementOther = document.querySelector('[name="field_research_interests[0][select_other_list]"]');
const graduateElement = document.querySelector('[name="field_graduate_fields[0][select_other_list]"]');
const centersElement = document.querySelector('[name="field_center_affiliations[select][]"]');

if (element) {
  /*const choices = new Choices(element, {
    removeItemButton: true
  });*/

  /*new Choices(centersElement, {
    removeItemButton: true
  });*/

  /*element.addEventListener('choice', event => {
    console.log(event.detail, 'event');
  });
  console.log(choices, 'choices');*/
}

if (graduateElement) {
  // const graduateChoices = new Choices(graduateElement);
}
